<template>
    <div class="main-body">
        <cabecalho-padrao/>
        <div class="main">
          <perfil/>
          <section class="main-lista">
            <div class="wrapper">
              <h2>Consulte suas RATs</h2> 
            </div>
            <div class="wrapper">
              <div class="filtro">
                <label>Filtro: </label>
                <div class="custom-select-wrapper">
                  <span class="icon"><img src="../assets/rectangle-list.png" alt="valores"></span>             
                  <select v-model="pesquisa.tipoFiltro"  class="custom-select"  @change="listar(false)">
                      <option value="todos">Todos</option>
                      <option value="pendente">Apenas Pendente</option>
                      <option value="finalizado">Apenas Finalizado</option>
                  </select>   
                </div>      
                <label>Ordenação: </label>
                <div class="custom-select-wrapper">
                  <span class="icon"><img src="../assets/rectangle-list.png" alt="valores"></span>             
                  <select v-model="pesquisa.tipoOrdem"  class="custom-select"  @change="listar(false)">
                      <option value="liberado">Recem Liberado</option>
                      <option value="cod_os">Nº OS</option>
                      <option value="data_os">Data OS</option>
                  </select>   
                </div>                 
              </div>
              <div class="paginacao">
                  <label> Pagina: {{paginaAtual}} de {{qtdePagina}} </label>
                  <button @click="Paginacao(-1)"><img src="../assets/left-arrow-gray.png"></button>
                  <button @click="Paginacao(1)"><img src="../assets/right-arrow-gray.png"></button>
              </div>     
            </div>  
            <div>
              <div class="main-grid">
                <div class="grid-card" v-for="lin in lista" :key="lin.id">
                  <div class="wrapper">
                    <div class="card-linha">
                      <h2>Nº OS: {{lin.cod_os}}</h2>
                      <h2>{{lin.data_os}}</h2>
                    </div>
                    <h3>{{lin.nome_cliente}}</h3>
                    <h3>Solicitante: {{lin.contato}}</h3>
                    <h4>Liberado: {{lin.rat_app_data_hora}}</h4>
                    <h4 v-if="lin.rat_app_finalizada=='X'">Finalizado: {{lin.rat_app_finalizada_data}}</h4>
                  </div>
                  <div class="botoes">   
                    <button @click="Editar(lin.cod_os,lin.rat_app_finalizada)" class="-esquerda">Editar</button>
                    <button @click="Visualizar(lin.cod_os)" class="-direita">Abrir PDF</button>
                  </div>                  
                </div>
                                  
              </div>
            </div>             
          </section>
      </div>
    </div>
</template>

<script>
import api from '../services/api.js';
import CabecalhoPadrao from '../components/Cabecalho.vue';
import Perfil from '../components/Perfil.vue';

export default {
  name: 'HomeView',
  components: {
    'cabecalho-padrao': CabecalhoPadrao,
    'perfil': Perfil,
  },
  data: () => ({
      pesquisa:{
          codTecnico: 22,
          tipoFiltro: "pendente",
          tipoOrdem: "liberado",
          limitIni: 0,
          limitFim: 20          
      },
      lista:[],  
      paginaAtual:1,
      qtdePagina:1,      

  }),
  methods: {
      async listar(paginacao){
            try {
                
                if (paginacao==false){
                    this.pesquisa.limitIni = 0;
                    this.pesquisa.limitFim = 20;
                    this.paginaAtual = 1;
                }
                else{
                    this.pesquisa.limitIni = 20*(this.paginaAtual-1);
                    this.pesquisa.limitFim = 20;
                }
                
                const response = await api.post('os/listar',this.pesquisa); // Aguarda a resposta da API
                console.log(response);

                this.qtdeRegistros = response.data.count;
                this.lista = response.data.qry;

                this.qtdePagina = Math.round(this.qtdeRegistros/20);
                if (this.qtdePagina<(this.qtdeRegistros/20))
                    this.qtdePagina = this.qtdePagina+1;

                

            } catch (error) {
                console.log(error);
                alert('Error - listar \n' + '-' + error.response?.data || error.message);
            }
      },
      async Paginacao(soma){
          if ((this.paginaAtual+soma)<1)
              this.paginaAtual = 1
          else 
          if ((this.paginaAtual+soma)>this.qtdePagina)
              this.paginaAtual = this.qtdePagina
          else{
              this.paginaAtual = this.paginaAtual+soma;
              this.listar(true);
          }          
      },
      Editar(codOS,Finalizada){
        if (Finalizada=='X')
          alert('RAT ONLINE finalizada')
        else
          this.$router.push('/rat/alterar/'+codOS);        
      },
      async Visualizar(codOS){
            try {
                
                let dados = {cod_os: codOS};
                const response = await api.post('/rat/imprimir',dados); // Aguarda a resposta da AP                
                console.log(response);
                if  (response.status==200){
                    var pdf = '../upload/'+response.data;
                    console.log(pdf);
                    window.open(pdf);

                   response.data
                }
                else
                  alert('## '+response.data);

                

            } catch (error) {
                console.log(error);
                alert('Error - dados OS \n' + '-' + error.response?.data || error.message);
            }
      }                 
  },
  async created(){
      this.pesquisa.codTecnico =  localStorage.getItem('codUsuarioLogado');

      await this.listar(false);
  }      
}
</script>


<style>
  @import '../css/components/main-body.css';
  @import '../css/components/custom/custom-select.css';  
  @import '../css/components/main-grid.css';    
  @import '../css/components/main-lista.css';   
   
</style>
